import { Component, Injectable, Input, OnInit, signal, WritableSignal } from '@angular/core';
import { AlertComponent, AlertType } from '../alert/alert.component';
import { CommonModule } from '@angular/common';

export type ApplicationMessageCode =
  'applicationApproved'
  | 'applicationSigned'
  | 'applicationNotSigned'
  | 'applicationSent'
  | 'notificationApproved'
  | 'notificationSigned'
  | 'notificationNotSigned'
  | 'notificationSent'
  | 'declarationApproved'
  | 'declarationSigned'
  | 'declarationNotSigned'
  | 'declarationSent'
  | 'paymentSuccess'
  | 'error';

export interface Alert {
  title: string;
  content: string;
  type: AlertType;
}

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  public alerts: WritableSignal<Alert[]> = signal([]);

  constructor() {
  }

  public show(n: Alert): void {
    setTimeout(() => {
      this.alerts.update((arr) => {
        arr.push(n);
        return arr;
      });
    });
  }

  public hide(i: number): void {
    setTimeout(() => {
      this.alerts.update((arr) => {
        arr.splice(i, 1);
        return arr;
      });
    });
  }

  public showByApplicationCode(code?: ApplicationMessageCode): void {
    switch (code) {
      case 'applicationApproved': {
        this.show({
          type: 'success',
          title: 'Status wniosku:',
          content: 'Twój wniosek został zatwierdzony.'
        });
        break;
      }
      case 'applicationSigned': {
        this.show({
          type: 'success',
          title: 'Status wniosku:',
          content: 'Twój wniosek został podpisany.'
        });
        break;
      }
      case 'applicationNotSigned': {
        this.show({
          type: 'danger',
          title: 'Status wniosku:',
          content: 'Twój wniosek nie został podpisany.'
        });
        break;
      }
      case 'applicationSent': {
        this.show({
          type: 'success',
          title: 'Status wniosku:',
          content: 'Twój wniosek został wysłany.'
        });
        break;
      }
      case 'notificationApproved': {
        this.show({
          type: 'success',
          title: 'Status zgłoszenia:',
          content: 'Twoje zgłoszenie zostało zatwierdzone.'
        });
        break;
      }
      case 'notificationSigned': {
        this.show({
          type: 'success',
          title: 'Status zgłoszenia:',
          content: 'Twoje zgłoszenie zostało podpisane.'
        });
        break;
      }
      case 'notificationNotSigned': {
        this.show({
          type: 'danger',
          title: 'Status zgłoszenia:',
          content: 'Twoje zgłoszenie nie zostało podpisane.'
        });
        break;
      }
      case 'notificationSent': {
        this.show({
          type: 'success',
          title: 'Status zgłoszenia:',
          content: 'Twoje zgłoszenie zostało wysłane.'
        });
        break;
      }
      case 'declarationApproved': {
        this.show({
          type: 'success',
          title: 'Status deklaracji:',
          content: 'Twoje deklaracja została zatwierdzona.'
        });
        break;
      }
      case 'declarationSigned': {
        this.show({
          type: 'success',
          title: 'Status deklaracji:',
          content: 'Twója deklaracja została podpisana.'
        });
        break;
      }
      case 'declarationNotSigned': {
        this.show({
          type: 'danger',
          title: 'Status deklaracji:',
          content: 'Twója deklaracja nie została podpisana.'
        });
        break;
      }
      case 'paymentSuccess': {
        this.show({
          type: 'success',
          title: 'Status wniosku:',
          content: 'Twoja płatnośc została zrealizowana.'
        });
        break;
      }
    }
  }
}

@Component({
  selector: 'app-alert-container',
  standalone: true,
  imports: [
    AlertComponent,
    CommonModule
  ],
  templateUrl: './alert-container.component.html'
})
export class AlertContainerComponent implements OnInit {

  @Input()
  public dismissible: boolean = true;

  constructor(public alertService: AlertService) {
  }

  public ngOnInit(): void {
    this.alertService.alerts.set([]);
  }
}
